// src/store/index.js
import { configureStore } from '@reduxjs/toolkit';
import tasksReducer from './slices/tasksSlice.js';
import filtersReducer from './slices/filtersSlice.js';
import toastsReducer from './slices/toastsSlice.js';

export const store = configureStore({
  reducer: {
    tasks: tasksReducer,
    filters: filtersReducer,
    toasts: toastsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['tasks/fetchAll/fulfilled'],
      },
    }),
  devTools: import.meta.env.DEV,
});
